import { Box, Text, Image } from "@chakra-ui/react";

const Info = (props: CardInfoProps) => {
  return (
    <Box
      border={"1px solid"}
      borderColor={"neutral.800"}
      px="1.25rem"
      py={"1.625rem"}
      borderRadius={"1rem"}
      width={"100%"}
      display={"flex"}
      justifyContent={"space-between"}
      gap={".5rem"}
      flexDirection={props.imagePosition === "left" ? "row-reverse" : "row"}
    >
      <Box>
        <Text fontSize={"xl"} fontWeight={"bold"} color={"whiteAlpha.900"}>
          {props.title}
        </Text>
        <Text mt={".7rem"} color={"whiteAlpha.800"}>
          {props.description}
        </Text>
      </Box>
      <Box>
        <Image src={props.ImageSrc} />
      </Box>
    </Box>
  );
};

export default Info;
